import { combineReducers } from "redux";
import customer from "../features/admin/customer/Slice";

const Customer = combineReducers({
  customer: customer,
});

export default Customer;
